module.exports = __webpack_public_path__ + "img/card_bogotaefficientlight_background.d10f989b.png";